import { Card, CardContent, CardHeader, CardTitle } from '~components/ui/card';

const OptimiserInstructions = () => (
  <Card>
    <CardHeader>
      <CardTitle className="font-bold text-foreground text-sm uppercase">Instructions</CardTitle>
    </CardHeader>
    <CardContent>
      <ul className="list-disc space-y-2 pl-4">
        <li className="text-foreground text-sm">Click any hole to view details</li>
        <li className="text-foreground text-sm">Drag to pan the view</li>
        <li className="text-foreground text-sm">Scroll to zoom in/out</li>
        <li className="text-foreground text-sm">Hover over holes for quick info</li>
      </ul>
    </CardContent>
  </Card>
);

export { OptimiserInstructions };
